import styled from "styled-components";

export const MenuContainer = styled.div`
  position: absolute;
  ${({ $autoTop }) => ($autoTop ? "" : "top: 100%;")}
  ${({ $anchor }) => ($anchor === "left" ? "left: 0;" : "right: 0;")}
  width: ${({ $anchor }) => ($anchor === "left" ? "auto" : "100%")};
  min-width: ${({ $minWidth }) => $minWidth || "auto"};
  margin-top: ${({ theme }) => theme.dropdownMenu.gap};
  background: ${({ theme }) => theme.backgroundDark};
  border: ${({ theme }) =>
    `${theme.border.standard} solid ${theme.border.color}`};
  border-radius: ${({ theme }) => theme.br.md};
  padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) =>
  theme.spacing[2]};
  z-index: ${({ theme }) => theme.zIndex.dropdown};
`;

export const PortalAnchor = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ $align }) =>
    $align === "left" ? "flex-start" : "flex-end"};
  gap: ${({ theme }) => theme.spacing[4]};
  height: ${({ theme }) => theme.dropdownMenu.itemHeight};
  padding: 0 ${({ theme }) => theme.spacing[3]};
  border-radius: ${({ theme }) => theme.br.md};
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  color: ${({ $selected, $disabled, theme }) =>
    $disabled ? theme.grey3 : theme.textLight};
  background: transparent;
  position: relative;
  user-select: none;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  font-family: ${({ theme }) => theme.p4b.ff};
  font-size: ${({ theme }) => theme.p4b.fs};

  &::before {
    content: "";
    position: absolute;
    inset: 3px 0;
    border-radius: ${({ theme }) => theme.br.md};
    background: ${({ $selected, theme }) =>
      $selected ? theme.backgroundLightest : "transparent"};
    pointer-events: none;
    transition: background 0.1s ease;
    z-index: -1;
  }

  ${({ $disabled, $selected, theme }) =>
    !$disabled &&
    `
    &:hover::before {
      background: ${$selected ? theme.backgroundLightest : theme.primary};
    }
  `}
`;
